import { apiClient } from './api-client';
import { ApiResponse, Exam, ListExamsResponse, CopyExamRequest, CopyExamResponse } from '../types';

export class ExamService {
  
  static async getExams(): Promise<ListExamsResponse> {
    try {
      const response = await apiClient.get<ApiResponse<ListExamsResponse>>('/exams');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching exams:', error);
      throw error;
    }
  }

  static async getExamById(id: number): Promise<Exam> {
    try {
      const response = await apiClient.get<ApiResponse<Exam>>(`/exams/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching exam:', error);
      throw error;
    }
  }

  static async createExam(examData: {
    name: string;
    code: string;
    description?: string;
    instructions?: string;
  }): Promise<Exam> {
    try {
      const response = await apiClient.post<ApiResponse<Exam>>('/exams', examData);
      return response.data.data;
    } catch (error) {
      console.error('Error creating exam:', error);
      throw error;
    }
  }

  static async updateExam(id: number, examData: {
    name?: string;
    code?: string;
    description?: string;
    instructions?: string;
  }): Promise<Exam> {
    try {
      const response = await apiClient.put<ApiResponse<Exam>>(`/exams/${id}`, examData);
      return response.data.data;
    } catch (error) {
      console.error('Error updating exam:', error);
      throw error;
    }
  }

  static async deleteExam(id: number): Promise<void> {
    try {
      await apiClient.delete(`/exams/${id}`);
    } catch (error) {
      console.error('Error deleting exam:', error);
      throw error;
    }
  }

  static async copyExam(id: number, copyData: CopyExamRequest): Promise<CopyExamResponse> {
    try {
      const response = await apiClient.post<ApiResponse<CopyExamResponse>>(`/exams/${id}/copy`, copyData);
      return response.data.data;
    } catch (error) {
      console.error('Error copying exam:', error);
      throw error;
    }
  }
}